import { createAction } from '@reduxjs/toolkit'

export const rehydrated = createAction('rehydrated')

export const transitionContentDelayed = createAction('transition/delayed')
export const transitionComplete = createAction('transition/complete')

export * from './routes'
export * from './layout'
